import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { Sidebar } from '../../../core/services/sidebar';

@Component({
  selector: 'app-navlink',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './navlink.html',
  styleUrls: ['./navlink.css'],
})
export class Navlink {
  @Input() label!: string;
  @Input() route?: string;
  @Input() action?: () => void;

  /** Single icon path */
  @Input() iconPath?: string;

  /** Style variant */
  @Input() variant: 'filled' | 'outlined' | 'plain' | 'db-link' | undefined = 'plain';

  /** Optional custom classes from parent */
  @Input() customClass = '';

  /** Optional icon styling (hover, active, color etc.) from parent */
  @Input() iconClass = '';

  constructor(private router: Router, private sidebarService: Sidebar) { }

  handleClick(): void {
    this.sidebarService.toggleSidebar();  //for mobile
    document.body.classList.remove('no-scroll'); //remove no-scroll class

    if (this.action) {
      this.action();
    }
    
    if (this.route) {  
      this.router.navigate([this.route]);
    }

  }

  get variantClass(): string {
    switch (this.variant) {
      case 'db-link':
        return 'text-(--text-muted) ';
      case 'filled':
        return 'bg-blue-600 text-white hover:bg-blue-700';
      case 'outlined':
        return 'border border-[#0051E8] text-(--text-accent) hover:bg-blue-50 rounded-3xl';
      case 'plain':
        return 'text-(--text-accent) hover:opacity-80';
      default:
        return 'text-(--text-accent) hover:opacity-90';
    }
  }
}
